import { createCRUDHook } from './createCRUDHook';
import { HolidayDto } from 'utils/models';
import { HOLIDAY } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<HolidayDto>({
  entityName: 'Holiday',
  endpoint: HOLIDAY,
});

export const HolidayContext = Context;
export const useHolidayManager = useManager;
export const useHoliday = useConsumer;
